<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="dep-create-form__section">
          <div class="dep-create-form__section-title">
            {{ $t('orgs.subdivision_data') }}
          </div>
          <div class="dep-create-form__section-row">
            <div class="dep-create-form__section-row-label">
              {{ $t('labels.title') }}:
            </div>
            <div class="dep-create-form__section-row-value">
              {{ depData.name }}
            </div>
          </div>
          <div class="dep-create-form__section-row">
            <div class="dep-create-form__section-row-label">
              {{ $t('labels.short_title') }}:
            </div>
            <div class="dep-create-form__section-row-value">
              {{ depData.abbr }}
            </div>
          </div>
          <!-- <div v-if="chiefData" class="dep-create-form__section-row">
            <div class="dep-create-form__section-row-label">
              {{ $t('orgs.director') }}:
            </div>
            <div class="dep-create-form__section-row-value">
              <span>{{ chiefData.getFullName() }}</span>
            </div>
          </div> -->
          <div class="dep-create-form__section-row">
            <div class="dep-create-form__section-row-label">
              {{ $t('orgs.is_part_of') }}:
            </div>
            <div class="dep-create-form__section-row-value">
              <template v-if="!depData.parent_id">
                {{ $t('orgs.head_org') }}
              </template>
              <template v-else>
                <dep-name :orgId="depData.parent_id" :showParent="true"></dep-name>
              </template>
            </div>
          </div>
        <div v-if="depData.description" class="dep-create-form__section">
          <div class="dep-create-form__section-title">
            {{ $t('labels.description') }}
          </div>
          <div class="dep-create-form__section-paragraph">{{ depData.description }}</div>
        </div>
        <div v-if="depData.address" class="dep-create-form__section">
          <div class="dep-create-form__section-title">
            {{ $t('labels.address') }}
          </div>
          <div class="dep-create-form__section-paragraph">{{ depData.address }}</div>
        </div>
        <div v-if="hasContacts()" class="dep-create-form__section">
          <div class="dep-create-form__section-title">
            {{ $t('labels.contacts') }}
          </div>
          <div class="dep-create-form__section-row" v-for="(contact, index) in depData.contacts" :key="index">
            <div class="dep-create-form__section-row-label">
              {{ contact.type}}
            </div>
            <div class="dep-create-form__section-row-value">
              {{ contact.value }}
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="dep-create__nav-buttons">
      <el-button @click="prev" icon="el-icon-arrow-left">{{ $t('labels.prev') }}</el-button>
      <el-button type="primary" @click="sendData">{{ $t('labels.end') }}</el-button>
    </div>
  </div>
</template>
<script>
  // import admin from 'src/api/admin';
  // import org from 'src/api/org'
  import depName from 'src/components/Orgs/OrgName.vue'

  export default {
    components: {
      depName
    },
    props: {
      depData: {
        type: Object,
        default () { return {} }
      },
      orgParent: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        servicesTable: null
      }
    },
    computed: {
    },
    methods: {
      sendData () {
        this.$emit('sendData')
      },
      prev () {
        this.$emit('prevStep')
      },
      hasContacts () {
        return this.depData.contacts.length;
      }
    }
  }
</script>